module.exports = __webpack_public_path__ + "public-ui/img/b4.22733c73.svg";